export type SigningOutputFormat = "asice" | "pdf";

export function canSignAsPdf(documents: Array<{ filename: string }>): boolean {
  return documents.length === 1 && /\.pdf$/i.test(documents[0].filename);
}

export function outputExtension(format: SigningOutputFormat): string {
  return format === "asice" ? ".asice" : ".pdf";
}
